<template>
  <div class="container-luid">
    <Card>
      <template slot="header">
        <h3>محصولات خریداری شده</h3>
        <hr />
      </template>
      <template slot="content">


        <div class="row Rounded border p-2 mx-2">
          <div class="col-1">ردیف</div>
          <div class="col-3">شناسه قرارداد</div>
          <div class="col-3">تاریخ شروع قرارداد</div>
          <div class="col-2">تاریخ پایان قرارداد</div>
          <div class="col-3">عملیات</div>
        </div>
        <!-- discount tax toll productName contractStartDate contractEndDate totallAmount  -->
        <div class="row mx-2" v-for="(item, index) in ContractList" :key="index">
          <div class="col-12 mt-2 Rounded border">
            <div class="row p-3">
              <div class="col-1">{{ index + 1 }}</div>
              <div class="col-3">{{ item.contractId }}</div>
              <div class="col-3">{{ item.contractStartDate }}</div>
              <div class="col-2">{{ item.contractEndDate }}</div>
              <div class="col-3">
                <a v-if="$session.get('UserInfo').tblGrpId != 449150" class="hover-danger" @click="Detail(index)"> جزئیات
                  <i class="fad fa-chevron-circle-down"></i> </a>
                <a v-if="$session.get('UserInfo').tblGrpId != 449150" class="hover-info mr-2"
                  @click="factorRequest(item.contractId)"> درخواست فاکتور <i class="fad fa-envelope"></i> </a>
              </div>

              <div v-if="$session.get('UserInfo').tblGrpId != 449150" :id="'detail' + index + ''"
                class="col-12 mt-3 Rounded" style="display: none;">

                <div class="d-flex p-2 Rounded justify-content-around" v-for="(p, ip) in item.products" :key="ip">
                  <div class="col-3">
                    <small>نام :</small>&nbsp;&nbsp;
                    <span>{{ p.productName }}</span>
                  </div>
                  <div class="col-2">
                    <small>قیمت :</small>&nbsp;&nbsp;
                    <span>{{ $Comma3ragham(p.totallAmount) }}</span>
                  </div>
                  <div class="col-2">
                    <small>تخفیف :</small>&nbsp;&nbsp;
                    <span>{{ $Comma3ragham(p.discount) }}</span>
                  </div>
                  <div class="col-2">
                    <small>مالیات :</small>&nbsp;&nbsp;
                    <span>{{ $Comma3ragham(p.tax) }}</span>
                  </div>
                  <div class="col-2">
                    <small>عوارض</small>&nbsp;&nbsp;
                    <span>{{ $Comma3ragham(p.toll) }}</span>
                  </div>
                </div>

              </div>


            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
export default {
  data() {
    return {
      ContractList: [],
      ticketConnection: null,
    }
  },
  components: { Card },
  methods: {
    GetCustomerProducts() {
      var DataAxios = { Action: 'Service/GetCustomerProduct', Method: 'POST', ArryfildValue: { Id: this.$session.get('CustomerInfo').Id } }
      this.$PostData(DataAxios).then((result) => {
        if (result.status == 'success') {
          this.ContractList = this.groupByContractId(result.data)
        } else {
          this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی بوجود امده است.', 'warning', 2000)
        }
      })
    },

    async factorRequest(contractId) {
      this.$RemoveAlert('از درخواست فاکتور رسمی')
        .then(result => {
          if (result) {
            this.createFactorTicket(contractId)
          }
        })
    },

    async createFactorTicket(contractId) {
      await this.connectHub()
      let title = 'درخواست فاکتور رسمی'
      let description = 'درخواست فاکتور رسمی برای قرارداد ' + contractId
      this.ticketConnection
        .invoke('CreateTicket', title, description, '1304482', String(this.$session.get('CustomerInfo').Id),
          '1800', String(this.$session.get('UserInfo').tblUserGrpId), '', null, '',
          'null', '1811').then((res) => { this.$mySweetDefaultTost('عملیات موفق', 'درخواست با موفقیت ایجاد شد', 'success', 2000) })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطا در ارسال', 'error', 3000)
          console.error('CATCH', error)
        })
    },

    async connectHub() {
      if(this.ticketConnection != null){
        return
      }
      await this.$GetSignalR().then((res) => {
        this.ticketConnection = res
        res.on("IdNewTicket", (idNewTicket, chatRoomId) => {
          setTimeout(() => {
            this.$router.push({
              name: 'ChatRoom',
              params: {
                ticketId: idNewTicket,
                chatRoomId: chatRoomId
              },
            })
          }, 130);
        })

      }).catch((error) => {
        this.$mySweetDefaultTost('عملیات ناموفق', 'خطا در ایجاد اتصال تیکت', 'error', 4000)
        console.error('CATCH', error)
      })
    },


    groupByContractId(list) {
      const groupBy = Object.groupBy(list, ({ tblContractId }) => tblContractId);
      let mapedOnKey = Object.keys(groupBy).map((key) => [key, groupBy[key]]);
      let result = []
      for (let index = 0; index < mapedOnKey.length; index++) {
        const element = mapedOnKey[index]

        const firsProduct = element[1][0]
        let item = {
          contractId: element[0],
          contractStartDate: firsProduct.contractStartDate,
          contractEndDate: firsProduct.contractEndDate,
          products: element[1]
        }
        result.push(item)
      }
      return result
    },

    Detail(index) {
      document.getElementById('detail' + index + '').style.display = document.getElementById('detail' + index + '').style.display == 'none' ? 'block' : 'none'
    },
  },

  created() {
    this.GetCustomerProducts()
  },

  beforeDestroy() {
    if(this.ticketConnection != null){
      this.ticketConnection.stop()
    }
  }
}

</script>
<style scoped>
.Rounded {
  border-radius: 35px !important;
  background: var(--sidebar-action-bg) !important;
  -webkit-box-shadow: 5px 5px 13px 3px rgba(0, 0, 0, 0.06);
  box-shadow: 5px 5px 13px 3px rgba(0, 0, 0, 0.06);
}
</style>
